module.exports = __webpack_public_path__ + "img/gorbunova.e332fe2d.png";